import React from "react"
import { styled, forwardRef, createStyles } from "@design-system/styled-system"
import { Icon, IconProps } from "@design-system/icons"
import { ListProps, ListItemProps } from "./types"

export const List = forwardRef<ListProps, "ul">((props, ref) => {
  const { children, styleType = "none", stylePosition, style, ...rest } = props

  return (
    <styled.ul
      {...rest}
      ref={ref}
      listStyleType={styleType}
      listStylePosition={stylePosition}
      role="list"
      style={[styles.list, style]}
    >
      {children}
    </styled.ul>
  )
})

List.displayName = "List"

export const ListItem = forwardRef<ListItemProps, "li">((props, ref) => {
  const { style, ...rest } = props
  return <styled.li {...rest} ref={ref} style={[styles.item, style]} />
})

ListItem.displayName = "ListItem"

export const ListItemIcon = forwardRef<IconProps, "svg">((props, ref) => {
  const { style, ...rest } = props
  return (
    <Icon
      {...rest}
      ref={ref}
      role="presentation"
      style={[styles.icon, style]}
    />
  )
})

ListItemIcon.displayName = "ListItemIcon"

export const OrderedList = forwardRef<ListProps, "ol">((props, ref) => {
  const { as, ...rest } = props
  return <List {...rest} ref={ref} as="ol" styleType="decimal" />
})

OrderedList.displayName = "OrderedList"

export const UnorderedList = forwardRef<ListProps, "ul">((props, ref) => {
  const { as, ...rest } = props
  return <List {...rest} ref={ref} as="ul" styleType="initial" />
})

UnorderedList.displayName = "UnorderedList"

const styles = createStyles((theme) => ({
  list: {
    margin: 0,
    padding: 0,
    marginLeft: theme.spaces.spacing16,
  },
  item: {
    listStyleType: "inherit",
  },
  icon: {
    marginRight: theme.spaces.spacing8,
  },
}))
